import { useEffect, useState } from "react";
import STCategoryCardList from "../../assets/styles/organisms/categoryCardList.module.scss";
import STSwiper from "../../assets/styles/molecules/swiper.module.scss";
import TApiResult from "../../types/api/TApiResult";
import {
  fetchCategories,
  TApiCategoriesResult,
} from "../../utils/api/fetchCategories";
import { routes } from "../../router/Router";
import CategoryCard from "../molecules/CategoryCard";
import { categorySummary } from "../../types/categorySummary";
import PAGE_CONFIG from "../../config/page";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react.js";

const CategoryCardList: React.FC = () => {
  const [categories, setCategories] = useState<categorySummary[]>([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 799);

  const updateMedia = () => {
    setIsMobile(window.innerWidth < 799);
  };

  useEffect(() => {
    window.addEventListener("resize", updateMedia);
    return () => {
      window.removeEventListener("resize", updateMedia);
    };
  }, []);

  useEffect(() => {
    fetchCategories(true).then((res: TApiResult & TApiCategoriesResult) => {
      if (!res.isSuccess || !res.result) {
        return;
      }

      const newCategories = res.result.map((res) => {
        return {
          id: res.id,
          name: res.name,
          linkUrl: res.slug
            ? `${routes.informations.path}?category_slug=${res.slug}`
            : `${routes.informations.path}?category=${res.id}`,
          imageUrl: res.image_url,
        };
      });

      setCategories(newCategories);
    });
  }, []);

  const SwiperComponent: React.FC = () => {
    const categoryLength = categories.length;
    return (
      <div className={STSwiper.swiper_container}>
        <Swiper
          className={STSwiper.category_swiper}
          loop={categoryLength > 2}
          spaceBetween={16}
          slidesPerView={2.8}
          initialSlide={0}
        >
          {categories.map((category) => {
            return (
              <SwiperSlide key={`slide-${category.id}`}>
                <CategoryCard {...category} />
              </SwiperSlide>
            );
          })}
          <div className={STSwiper.banner_pagination}></div>
        </Swiper>
      </div>
    );
  };
  return (
    <>
      {categories.length > 0 && (
        <section className={STCategoryCardList.category_card_list}>
          <div
            className={`${STCategoryCardList.category_card_list_title} ${PAGE_CONFIG.STATIC_CLASSES.SUBJECT}`}
          >
            カテゴリ
          </div>
          <div className={STCategoryCardList.category_card_list_wrap}>
            {isMobile ? (
              <SwiperComponent />
            ) : (
              categories.map((category) => (
                <CategoryCard key={category.id} {...category} />
              ))
            )}
          </div>
        </section>
      )}
    </>
  );
};

export default CategoryCardList;
